export const paths = {
  dashboard: '/dashboard',
  onboarding: '/onboarding',

  clients: '/clients',
  client: (id: number) => `/clients/${id}`,
  newClient: '/clients/new',
  editClient: (id: number) => `/clients/${id}/edit`,

  cep: (code: string) => `/ceps/${code}`,

  serviceOrders: '/service_orders',
  serviceOrder: (id: number) => `/service_orders/${id}`,
  newServiceOrder: '/service_orders/new',

  invoices: '/invoices',
  invoice: (id: number) => `/invoices/${id}`,

  paymentReminders: '/payment_reminders',
  paymentReminderSchedule: '/payment_reminders/schedule',
  editPaymentReminderSchedule: '/payment_reminders/schedule/edit',

  products: '/products',
  product: (id: number) => `/products/${id}`,
  newProduct: '/products/new',
  editProduct: (id: number) => `/products/${id}/edit`,

  services: '/services',
  service: (id: number) => `/services/${id}`,
  newService: '/services/new',
  editService: (id: number) => `/services/${id}/edit`,

  ledgerEntries: '/ledger_entries',
  ledgerEntry: (id: number) => `/ledger_entries/${id}`,
  newLedgerEntry: '/ledger_entries/new',
  editLedgerEntry: (id: number) => `/ledger_entries/${id}/edit`,

  plans: '/plans',
  plan: (id: number) => `/plans/${id}`,
  newPlan: '/plans/new',
  editPlan: (id: number) => `/plans/${id}/edit`,

  billing: '/settings/billing',
  billingPaymentMethod: '/settings/billing/payment_method',
  newBillingPaymentMethod: '/settings/billing/payment_method/new',
  settingsAccount: '/settings/account',
  settingsAuthentication: '/settings/authentication',
  settingsNotifications: '/settings/notifications',
  users: '/settings/users',
  passwordRecovery: '/password_recoveries/new',
  subscribe: '/subscribe',
  subscriptionChange: '/subscription_change',
  newSubscriptionChange: (plan: string) => `/subscription_change/new?plan=${plan}`,
  checkout: (plan: string) => `/checkout/${plan}`,
};
